import React, {useEffect} from "react";
import "./DailyBlogsPage.scss";
import {useLocation, useParams} from "react-router-dom";
import Blog5 from "./DailyBlogs/Blog5";
import Blog6 from "./DailyBlogs/Blog6";
import Blog7 from "./DailyBlogs/Blog7";
import Blog8 from "./DailyBlogs/Blog8";
import Blog9 from "./DailyBlogs/Blog9";
import Blog10 from "./DailyBlogs/Blog10";
import Blog11 from "./DailyBlogs/Blog11";
import Blog12 from "./DailyBlogs/Blog12";
import Blog13 from "./DailyBlogs/Blog13";
const DailyBlogsPage = () => {
  const {blogId} = useParams();
  console.log(blogId, "blogIdblogId");
  useEffect(() => {}, []);
  return (
    <div className="dailyBlogsPageContainer">
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 5 && <Blog5 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 6 && <Blog6 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 7 && <Blog7 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 8 && <Blog8 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 9 && <Blog9 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 10 && <Blog10 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 11 && <Blog11 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 12 && <Blog12 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 13 && <Blog13 />}</div>
    </div>
  );
};

export default DailyBlogsPage;
